import React, { useEffect, useState } from "react";
import classNames from "classnames";
import "./modalComponent.scss";
import { useTranslation } from "react-i18next";

const ModalComponent = ({
  backgroundDrop,
  isOpen = false,
  onCloseModal,
  className = "",
  idName = "",
  descriptionText = "", // Description text to be displayed
  needConfirmation = false, // true or false
  onConfirm, // methods to execute on Click of Primary Yes Button
  onClose, // methods to execute on Click of Secondary No Button
  onAcceptance, // methods to execute on Click of OK Button
  primaryBtnText = "", // Incase there is requirement to replace Primary- "Yes" text
  primaryTextIcon = "",
  secondaryBtnText = "", // Incase there is requirement to replace Secondary- "No" text
  children = "",
  okBtnText= ""
}) => {
  const { t } = useTranslation("global");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const backDropClick = (e) => {
    if (backgroundDrop) {
      setIsModalOpen(false);
      onCloseModal();
    }
  };

  const closeModal = () => {
    onAcceptance && onAcceptance();
    setIsModalOpen(false);
    onCloseModal();
  };

  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  const onNoConfirmation = () => {
    onClose && onClose();
    closeModal();
  };

  const onYesConfirmation = () => {
    onConfirm && onConfirm();
    closeModal();
  };

  return (
    <>
      {isModalOpen && (
        <div className="modalWrapper" onClick={backDropClick}>
          <div
            className={classNames("innerModal", className)}
            id={idName}
            onClick={(e) => e.stopPropagation()}
          >
            {descriptionText ? (
              <p className="text-center" id="description_text">
                {descriptionText}
              </p>
            ) : (
              <></>
            )}
            {children}

            {needConfirmation ? (
              <div className="confirmationDiv fluid d-flex justify-content-center">
                <button
                  className="modalClose"
                  id="Yes_confirmation"
                  onClick={onYesConfirmation}
                >
                  <span>
                    {primaryBtnText ? (
                      <>
                        <>{primaryBtnText}</>
                        <span id="primaryTextIcon">{primaryTextIcon}</span>
                      </>
                    ) : (
                      <>{t("yes_message")}</>
                    )}
                  </span>
                </button>
                <button
                  className="modalClose"
                  id="No_confirmation"
                  onClick={onNoConfirmation}
                >
                  <span>
                    {secondaryBtnText ? (
                      secondaryBtnText
                    ) : (
                      <>{t("no_message")}</>
                    )}
                  </span>
                </button>
              </div>
            ) : (
              <>
                <div className="confirmationDiv fluid d-flex justify-content-center">
                  <button
                    className="modalClose"
                    id="okay_confirmation"
                    onClick={closeModal}
                  >
                    <span>
                      {okBtnText ? okBtnText : <>{t("ok_message")}</>}
                    </span>
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ModalComponent;
